<template>
  <li class="profile-nav onhover-dropdown p-0 mr-0">
    <div class="media profile-media">
      <img
        class="b-r-10"
        :src="ImageEndpoint + UserImage"
        v-if="UserImage && UserImage != 1"
        style="height: 36px; width: 36px"
      />
      <div
        v-else
        class="rounded-circle randon-picture-action-needed rounded-circle profile-no-image"
      >
        {{ NoImageName }}
      </div>
      <div class="media-body">
        <span>{{ Name }}</span>
        <p class="mb-0 font-roboto">
          <span>{{ Company_role }}</span>
          <i class="middle fa fa-angle-down header-extra-buttons"></i>
        </p>
      </div>
    </div>
    <ul class="profile-dropdown onhover-show-div header-extra-buttons">
      <!--<li>
        <router-link to="/setting"><feather type="user"></feather><span>Account </span></router-link>
      </li>-->
      <!--<li>
        <a href="#"><feather type="mail"></feather><span>Inbox</span></a>
      </li>
      <li>
        <a href="#"
          ><feather type="file-text"></feather><span>Taskboard</span></a
        >
      </li>-->
      <li>
        <router-link to="/settings"
          ><feather type="settings"></feather><span>Settings</span></router-link
        >
      </li>
      <li>
        <router-link to="/update-profile"
          ><feather type="edit"></feather
          ><span>Update Profile</span></router-link
        >
      </li>
      <li>
        <a class="cursor-pointer" id="changePassword" v-b-modal.change-profile-password
          ><font-awesome-icon icon="fa-solid fa-key" />
          <span>Change Password</span></a
        >
      </li>
      <li>
        <a @click="logout"
          ><feather type="log-in"></feather><span>Log out</span></a
        >
      </li>
    </ul>
  </li>
</template>

<script>
  import firebase from "firebase";
  import UserAuth from "../../auth/js/index";
  import $ from "jquery";

  export default {
    name: "Profile",
    data() {
      return {
        Name: "",
        UserImage: "",
        Company_role: "",
        CompanyLogo: "",
        NoImageName: "",
        ImageEndpoint: Endpoints.Helper.Image + "/",
      };
    },
    mounted() {
      var User = JSON.parse(localStorage.getItem("User"));
      this.Name = User.forename + " " + User.surname;
      this.NoImageName = User.forename.charAt(0) + User.surname.charAt(0);
      if (User.profile_image) {
        this.UserImage = User.profile_image;
      }
      var Company = JSON.parse(localStorage.getItem("Company"));
      this.CompanyLogo = Company.logo;
      this.Company_role = JSON.parse(localStorage.getItem("permissions")).title;

      if(localStorage.getItem("PasswordReset") && localStorage.getItem("PasswordReset") == 1){
        setTimeout(() => {
          $('#changePassword')[0].click();
          localStorage.removeItem('PasswordReset');
        }, 500);
      }
    },
    methods: {
      logout: function () {
        firebase
          .auth()
          .signOut()
          .then(() => {
            UserAuth.Logout();
            this.$router.replace("/auth/login");
          });
      },
    },
  };
</script>
<style scoped>
  .profile-no-image {
    background-color: #eee;
    padding: 8px 10px;
    text-transform: uppercase;
  }
</style>
